export default __webpack_public_path__ + "static/media/1.da193b77.png";